/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationForAzureCsp extends models.BillingPeriodInformation {
    getFixupPrototypeFunction() { return BillingInformationForAzureCsp.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationForAzureCsp>): BillingInformationForAzureCsp {
        let obj = Object.assign(new BillingInformationForAzureCsp(), model);
        BillingInformationForAzureCsp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationForAzureCsp>): BillingInformationForAzureCsp {
        if (!model) return null;
        return BillingInformationForAzureCsp.newInstance(<BillingInformationForAzureCsp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationForAzureCsp) {
        if (!obj) return;

        models.BillingInformationForAzureCsp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationForAzureCsp): boolean {
        if (models.BillingPeriodInformation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationForAzureCsp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
